import React from "react";

interface ServerStatsProps {
  title: string;
  metric1: string;
  metric2: string;
  metric3: string;
  trend: string;
  trendColor: string;
}

const ServerStats: React.FC<ServerStatsProps> = ({
  title,
  metric1,
  metric2,
  metric3,
  trend,
  trendColor,
}) => {
  return (
    <div className="widget server-stats">
      <div className="widget-header">
        <h3>{title}</h3>
      </div>
      <div className="widget-body">
        <div className="metrics">
          <div className="metric-row">
            <span className="metric-label">{metric2}</span>
            <span className="metric-value">{metric1}</span>
          </div>
          <div className="metric-row">
            <span className="metric-label">{metric3}</span>
          </div>
        </div>
        <div className="trend-indicator">
          <span className={trendColor}>{trend}</span>
        </div>
      </div>
    </div>
  );
};

export { ServerStats };